import { render } from "./EditCustomerType.vue?vue&type=template&id=51571ca1&scoped=true"
import script from "./EditCustomerType.vue?vue&type=script&lang=js"
export * from "./EditCustomerType.vue?vue&type=script&lang=js"

import "./EditCustomerType.vue?vue&type=style&index=0&id=51571ca1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51571ca1"]])

export default __exports__